import React from 'react';
import Experience from '../Components/Experience/Experience';

const ExperiencePage = () => {
  return (
    <>
      <Experience />
    </>
  );
};

export default ExperiencePage;
